import $ from "jquery";

$(document).ready(function(){
  // page project register
  if (window.currentPage == "project_register") {
    var business_scope1 = $('#business_scope1').val();
    if (business_scope1 && business_scope[business_scope1].hasOwnProperty('children')){
      $('#business_scope2').parent().removeClass('jsBLockSelect2');
    }
    var occupation_type1 = $('#occupation_type1').val();
    if (occupation_type1 && occupation_type[occupation_type1].hasOwnProperty('children')){
      $('#occupation_type2').parent().removeClass('jsBLockSelect2');
    }
    $('#business_scope1').on('change', function(){
      $('#business_scope_other').val('');
      business_scope1 = $(this).val();
      var html = '<option value="" disabled="" selected="" hidden="">選択する</option>';
      if (business_scope[business_scope1].hasOwnProperty('children')){
        const business_scope2 = business_scope[business_scope1]['children']
        $.each(business_scope2, function (key, value) {
            html+= '<option value="'+key+'">'+value+'</option>'
        });
        $('#business_scope2').parent().css('display', 'block')
        $('#business_scope_other').addClass('noDisplay')
      }else{
        $('#business_scope2').parent().css('display', 'none')
        if (business_scope1 == 14) {
          $('#business_scope_other').removeClass('noDisplay')
        }else{
          $('#business_scope_other').addClass('noDisplay')
        }
      }
      $('#business_scope2').html(html)
    })

    $('#occupation_type1').on('change', function(){
      occupation_type1 = $(this).val();
      var html = '<option value="" disabled="" selected="" hidden="">選択する</option>';
      if (occupation_type[occupation_type1].hasOwnProperty('children')){
        const occupation_type2 = occupation_type[occupation_type1]['children']
        $.each(occupation_type2, function (key, value) {
          html+= '<option value="'+key+'">'+value+'</option>'
        });
        $('#occupation_type2').parent().css('display', 'block')
      }else{
        $('#business_scope2').parent().css('display', 'none')
      }
      $('#occupation_type2').html(html)
    })

    $('#industry').on('change', function(){
      $('#client_industry_other').val('');
      var industry = $(this).val();
      if (industry == 78) {
        $('#client_industry_other').removeClass('noDisplay')
      }else{
        $('#client_industry_other').addClass('noDisplay')
      }
    })

    if ($('#fixed_salary').val()) {
      var fixed_salary = $('#fixed_salary').val().replace(/,/g, '')
      $('.fixedSalaryIncludeTax').text('（税込' + formatNumber((fixed_salary * 1.1) || 0) + '円）');
    }
    $('#fixed_salary').on('change', function(){
      var fixed_salary = $(this).val().replace(/,/g, '')
      var fixed_salary_tax = (fixed_salary * 1.1) || 0
      $('.fixedSalaryIncludeTax').text('（税込' + formatNumber(fixed_salary_tax) + '円）');
    })

    calculation()
    $('.calculation').on('change', function () {
      calculation()
    })

    function formatNumber(x) {
      x = parseFloat(x);
      var parts = x.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function calculation(){
      let hourly_salary = $('input[name="hourly_salary"]').length ? $('input[name="hourly_salary"]').val().replace(/,/g, '') : 0;
      let working_time_month = $('input[name="working_time_month"]').length ? $('input[name="working_time_month"]').val().replace(/,/g, '') : 0;
      let months = $('input[name="working_month"]').length ? $('input[name="working_month"]').val().replace(/,/g, '') : 0;
      let month_income = (hourly_salary*working_time_month) || 0;
      $('.month_income').text(formatNumber(month_income) + '円（税込' + (formatNumber(month_income*1.1)) + '円）');
      let total_salary = (month_income*months) || 0;
      $('.total_salary').text(formatNumber(total_salary) + '円（税込' + (formatNumber(total_salary*1.1)) + '円）');
    }

    $('#jsChooseExpert').click(function(e){
      e.preventDefault();
      var data = $('#frmEditProject').serializeArray();
      var redirect_url = $(this).attr('href')
      var url = $(this).data('url-temp-save');
      return $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        data: data,
        type: 'post',
        dataType: "json",
        beforeSend: function () {
        },
      }).done(function (res) {
        if (res.success == true) {
          window.location.href = redirect_url
        }
      });
    })

    $('.jsRemoveExpert').click(function(){
      var that = $(this)
      var id = $(this).data('id');
      var type = $(this).data('type');
      return $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/assign-experts',
        url: '/assign-experts',
        data: {'id': id, 'type': type},
        type: 'post',
        dataType: "json",
      }).done(function (res) {
        that.parents('.card2').remove();
      });
    })
  }
  //end page project register

  // page project manager
  if (window.currentPage == 'project_manager') {
    $('#order').on('change', function(){
      $('#frmSearchProject').submit()
    })

    $('#orderbBy').on('change', function(){
      $('#frmSearchProject').submit()
    })

    $('.jsItem').click(function(){
      var transactions = []
      var id = $(this).data('id')
      var input = $(this).next('input')
      if($(input).is(':checked')){
        $(input).prop('checked', false);
      }else{
        $(input).prop('checked', true);
      }
      $('#frmSearchProject').submit()
    })
  }
  //end page project manager
})
